import React from "react";
import { Container, Grid, Paper, Typography, Box } from "@mui/material";
import FarmerStats from "../../components/Admin/FarmerStats";
import AreaSplitChart from "../../components/Admin/AreaSplitChart";
import CoverageStatus from "../../components/Admin/CoverageStatus";
import NutrientProfile from "../../components/Admin/NutrientProfile";
import SoilQuality from "../../components/Admin/SoilQuality";
import CustomAppBar from "../../components/AppBar";
import { t } from "i18next";

const OverviewDashboard = () => {
  return (
    <Box>
      <CustomAppBar />
      <Container>
        <Typography variant="h4" align="center" gutterBottom sx={{ mt: 4 }}>
          {t("Overview Dashboard")}
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper elevation={3}>
              <FarmerStats />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} align="center">
            <Paper elevation={3}>
              <Typography variant="h6" sx={{ paddingTop: 2 }}>
                {t("Farms Area-wise Split")}
              </Typography>
              <AreaSplitChart />
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} align="center">
            <Paper elevation={3}>
              <Typography variant="h6" sx={{ paddingTop: 2 }}>
                {t("Satellite Data and IoT Coverage")}
              </Typography>
              <CoverageStatus />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3}>
              <Typography variant="h6" sx={{ paddingTop: 2, paddingLeft: 2 }}>
                {t("Nutrient Profile")}
              </Typography>
              <NutrientProfile />
            </Paper>
          </Grid>
          <Grid item xs={12}>
            <Paper elevation={3}>
              <Typography variant="h6" sx={{ paddingTop: 2, paddingLeft: 2 }}>
                {t("Soil Quality")}
              </Typography>
              <SoilQuality />
            </Paper>
          </Grid>
          {/* <Grid item xs={12}>
            <Paper elevation={3}>
              <Typography variant="h6" sx={{ paddingTop: 2, paddingLeft: 2 }}>
                {t("Crop Monitoring (Satellite Metrics)")}
              </Typography>
              <CropMonitoringReport />
            </Paper>
          </Grid> */}
        </Grid>
      </Container>
    </Box>
  );
};

export default OverviewDashboard;
